'use client';

import { Controller, type SubmitHandler, useForm } from 'react-hook-form';
import { Trans } from '@lingui/react';
import { Button } from '@startuptools/ui/Button';
import { FormControl } from '@startuptools/ui/FormControl';
import { FormLabel } from '@startuptools/ui/FormLabel';
import { Option } from '@startuptools/ui/Option';
import { Select } from '@startuptools/ui/Select';
import { Box } from '@startuptools/ui/Box';
import { Stack } from '@startuptools/ui/Stack';
import { fictitiousIdentities, type I } from './fictituous';

type FormValues = {
  identity: I;
};

interface Props {
  handleCreate: (identity: I) => Promise<unknown>;
}

export const InputFictitious = ({ handleCreate }: Props) => {
  const form = useForm<FormValues>({
    defaultValues: { identity: undefined },
  });

  const onSubmit: SubmitHandler<FormValues> = ({ identity }) => {
    return handleCreate({
      ...identity,
    });
  };

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Stack direction="column" gap={2}>
          <FormControl>
            <FormLabel>
              <Trans id="Identity" />
            </FormLabel>
            <Controller
              control={form.control}
              name="identity"
              render={({ field }) => (
                <Select
                  placeholder="Select identity"
                  value={field.value ? field.value.id : ''}
                  onChange={(_e, value) => {
                    const selectedIdentity = fictitiousIdentities.find(i => i.id === value);
                    field.onChange(selectedIdentity);
                  }}
                >
                  {fictitiousIdentities.map(i => (
                    <Option key={i.id} value={i.id}>
                      {i.name} - {i.label}
                    </Option>
                  ))}
                </Select>
              )}
            />
          </FormControl>

          <Box alignSelf="end">
            <Button type="submit">
              <Trans id="Save" />
            </Button>
          </Box>
        </Stack>
      </form>
    </>
  );
};
